// Recognises the error a browser throws when a lazy route's chunk (or the CSS
// Vite preloads for it) cannot be loaded. Two causes reach production:
//
// - A stale chunk: the tab is running a build older than the live one, and a
//   later deploy removed its files. The server answers the missing .js with
//   index.html (SPA fallback), so the browser gets HTML for a module script.
//   Only a reload, which fetches the live index.html, can fix it.
// - A failed fetch on the live build: a dropped connection on a store machine,
//   or a deploy caught halfway. Retrying the same import can fix it.
//
// The wording differs per engine: Chromium "Failed to fetch dynamically
// imported module", Firefox "error loading dynamically imported module",
// Safari "Importing a module script failed", and Vite's preload helper "Unable
// to preload CSS" / "CSS chunk load failed".
//
// Imports nothing and has no module-level side effects: instrument.js uses it
// to group these events in Sentry, and must stay ahead of the app graph.
const CHUNK_ERROR_RE =
    /failed to fetch dynamically imported module|error loading dynamically imported module|importing a module script failed|unable to preload css|css chunk load failed/i;

export const isChunkLoadError = (error) =>
    CHUNK_ERROR_RE.test(String(error?.message ?? error ?? ""));

// "https://host/assets/BuildMyHoliday-DnqE-_Nc.js" -> "BuildMyHoliday". The
// hash changes on every deploy and the module name does not, so this is the
// key to count failures per route by.
export const chunkNameFromError = (error) => {
    const match = String(error?.message ?? error ?? "").match(
        /\/([A-Za-z0-9_$]+)-[A-Za-z0-9_-]{8}\.(?:js|css)\b/
    );
    return match ? match[1] : undefined;
};
